import { camelCase } from 'lodash-es';
import { isDataSelector, stripFirstCharacter, extractDataSelector } from './general';

export default function selectSiblings(el, selector) {
  return [...el.parentNode.children].filter((child) => {
    if (child === el) {
      return false;
    }

    if (selector && selector.startsWith('.')) {
      return child.classList.contains(stripFirstCharacter(selector));
    }

    if (selector && selector.startsWith('#')) {
      return child.id === stripFirstCharacter(selector);
    }

    if (selector && isDataSelector(selector)) {
      const dataSelector = extractDataSelector(stripFirstCharacter(selector));

      return child.dataset[camelCase(dataSelector)] !== undefined;
    }

    return true;
  });
}
